import React, { useEffect, useState } from 'react';
import PaginaImprimir from './PaginaImprimir';


export const ImprimirEmpresasInscriptas = ({empresas, evento}) => {
    const [empresasPaginas, setEmpresasPaginas]=useState([]); 

    useEffect(() => {
        let elemPagina = []; 
        setEmpresasPaginas([]);
        for (var i = 0; i < empresas.length; i++) {
            
            elemPagina.push(empresas[i]); 
            if( (i + 1) % 13 == 0 && i !== 0){
                const objeto = elemPagina;
                setEmpresasPaginas(empresasPaginas => [...empresasPaginas, objeto]) 
                elemPagina = []; 
            }
        }
        if(elemPagina.length > 0){
            setEmpresasPaginas(empresasPaginas => [...empresasPaginas, elemPagina]) 

        }
    },[empresas]) 
    return(  
        <>  
            <div id='imprimirEmpresasInscriptas' className='seccionImprimir'>
                {empresasPaginas.length !== 0?
                    empresasPaginas.map(function(el, i){
                        return( 
                            <PaginaImprimir eventoActual={evento} reuniones={el} esEmpresas={true}/>
                        )
                                    
                    })
                :
                    <><PaginaImprimir eventoActual={evento} reuniones={[]} esEmpresas={true}/></>   
                }
            </div>

        </>
    );
}

